<template lang="html">
  <div class="alert alert-warning">
    <div>
      <strong>Trade Available</strong>
    </div>
    <div>
      Another player would like to trade with you.
      <router-link :to="`/leagues/${league}/trades/`" class="fc-a-link--warning"
        >See trades</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TradesAvailable",
  props: {
    league: { type: Number }
  }
};
</script>

<style lang="css" scoped></style>
